import React from 'react';

export const ChevronUp = ({ width = 24, height = 24, color = '#000000' }) => (
  <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill={color} d="M12.768,8.359a1.035,1.035,0,0,0-1.536,0l-5,6A1,1,0,0,0,7,16H17a1,1,0,0,0,.768-1.641ZM9.135,14,12,10.563,14.865,14Z"/>
  </svg>
);
